<template>
  <div id="AltaComponent" class>
    <div class="titleAlta">
      <h1 class="titleAltah1">Alta</h1>
    </div>
    <div class="containerAlta">
      <div>
        <div v-if="popup" class="popupAlta">
          <div class="popupAltaH">
            <p class="mt-3 ppopupAlta">El proceso de alta ha finalizado con éxito</p>
            <button  class="btn btn-success btnpopupAlta " @click="cerrarPopup()" >Aceptar</button>
          </div>
        </div>
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <p class="filterName subTitleContracts">Información del alta</p>
            <b-button v-b-toggle.accordion-1 class="filterToggleBtn">{{filterAccordionBtnText}}</b-button>
          </b-card-header>
          <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel" class="filterBox">
            <b-col cols="12" sm="6" md="4" lg="4" xl="4">
            <button ref="persona" class="btn btn-secondary " value="P" @click="userPersona()" style="background-color:#278BED">Persona</button>
            <button ref="sociedad" id="sociedad" class="btn btn-secondary"  value="S" @click="userSociedad()">Sociedad</button>
            </b-col>
            <b-card-body>
              <b-col cols="12">
                <b-row>
                  <b-col cols="12" sm="6" md="4" lg="4" xl="4">
                    <b-row>
                      <b-col cols="6">
                        <p>* Nº Necesidad:</p>
                      </b-col>
                      <b-col cols="6">
                        <input class="form-control" label="Id Contrato" id="idNeed" type="number" v-model="idNeed" v-on:input="($event) => { DisableBtn($event); limitDigits($event, 'idNeed', 11); }"/>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" lg="4" xl="4">
                    <b-row>
                      <b-col cols="6">
                        <p>* Nombre:</p>
                      </b-col>
                      <b-col cols="6">
                        <input class="form-control" id="name"  maxlength="30" type="text" @keyup="DisableBtn($event)" ref="name"/>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" lg="4" xl="4">
                    <b-row>
                      <b-col cols="6">
                        <p>* Primer apellido:</p>
                      </b-col>
                      <b-col cols="6">
                        <input class="form-control" id="surname1"  maxlength="30" type="text" @keyup="DisableBtn($event)" ref="surname1"/>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" sm="6" md="4" lg="4" xl="4">
                    <b-row>
                      <b-col cols="6">
                        <p>* Segundo apellido:</p>
                      </b-col>
                      <b-col cols="6">
                        <input class="form-control" id="surname2"  maxlength="30" type="text" @keyup="DisableBtn($event)" ref="surname2"/>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" lg="4" xl="4">
                    <b-row>
                      <b-col cols="6">
                        <p class="">* Número de teléfono:</p>
                      </b-col>
                      <b-col cols="6">
                        <input class="form-control" id="Numbertlf" type="tel" pattern="([+]?[0-9]{11})|([0-9]{9})" maxlength="12" v-model="phoneNo" v-on:keyup="DisableBtn($event)" ref="Numbertlf"/>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" lg="4" xl="4">
                    <b-row>
                      <b-col cols="6">
                        <b-row>
                          <b-col cols="12" sm="12" md="12" lg="12" xl="6">
                            <span>*</span>
                            <input type="radio" id="radioNif" value="nif" v-model="radioSelected" @change="changeRadioNif()"/>
                            <span> NIF/NIE </span>
                          </b-col>
                          <b-col cols="12" sm="12" md="12" lg="12" xl="6" class="divRadioPasaporte">
                            <input type="radio" id="radioPasaporte" value="pasaporte" v-model="radioSelected" @change="changeRadioNif()"/>
                            <span> Pasaporte </span>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col cols="6">
                        <input class="form-control" :maxlength="getInputMaxLength"  type="text" id="nif" @keyup="DisableBtn($event)" ref="nif"/>
                      </b-col>
                    </b-row>
                  </b-col>
                  <!-- new razon social -->
                </b-row>
                <b-row>
                  <b-col cols="12" sm="6" md="4" lg="4" xl="4">
                    <b-row>
                      <b-col cols="6">
                        <p>* Dirección PS:</p>
                      </b-col>
                      <b-col cols="6">
                        <input class="form-control" maxlength="255"  type="text" id="address" @keyup="DisableBtn($event)" ref="address"/>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" lg="4" xl="4" ref="socialdisplay" v-show="isSocial">
                    <b-row>
                      <b-col cols="6">
                        <p>* Razon social:</p>
                      </b-col>
                      <b-col cols="6">
                        <input class="form-control"  maxlength="40" type="text" id="social" @keyup="DisableBtn($event)" ref="social"/>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" lg="4" xl="4" v-show="isSocial">
                    <b-row>
                      <b-col cols="6">
                        <p ref="cifText">* CIF:</p>
                      </b-col>
                      <b-col cols="6">
                        <input class="form-control"   maxlength="9" type="text" id="cif" @keyup="DisableBtn($event)" ref="cif"/>
                      </b-col>
                    </b-row>
                  </b-col>
                <!-- new razon social end -->
                </b-row>
              </b-col>
              <b-col>
                <b-row>
                  <b-col>
                    <p class="asteriskInfo">* Campos obligatorios</p>
                  </b-col>
                </b-row>
              </b-col>
              <button @click="addFilesModal()" :disabled="disabledAddFiles" class="btn">+ Añadir Archivos</button>
              <div class="tablaAltas">
                <b-row class="tablaContratos">
                  <b-col v-for="(title,index) in headTitle" :key="index">{{title}}</b-col>
                </b-row>
                <b-row v-for="(contract,index) in contract_list" :key="index" v-model="contract_list" class="tablaContratos">
                  <b-col>{{contract.number_io}}</b-col>
                  <b-col>{{contract.type_contract}}</b-col>
                  <b-col v-if="contract.cups_luz">{{contract.cups_luz}}</b-col>
                  <b-col v-else-if="contract.cups_gas">{{contract.cups_gas}}</b-col>
                  <b-col v-else></b-col>
                  <b-col>{{contract.file_name}}</b-col>
                  <b-col>
                    <button title="Eliminar contrato" @click="eraseContractFromList(contract.number_io)" class="tableIconBtn">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </b-col>
                </b-row>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <div>
        <p ref="pbtnalt" class="subTitleAlta cabeceraalt"></p>
        <button ref="Btnalt" class="btn btn-secondary Btnalt" disabled @click="enviar()" >Enviar</button>
      </div>
    </div>
    <b-modal ref="msg_modal" id="msgModal" hide-footer>
      <div id="divMsg" ref="divMsg" class="d-block text-center">
        <h3 v-for="(errorMsg,index) in errorsMsg" :key="index" v-bind:value="errorMsg">{{errorMsg}}</h3>
      </div>
      <b-button class="mt-3" block @click="hideModal">Cerrar</b-button>
    </b-modal>
    <!-- Modal añadir archivos -->
    <b-modal ref="addfile_modal" id="msgModal" hide-footer>
      <h3>Subir archivos</h3>
      <p>Numero OI:</p>
      <input class="form-control" @keyup="checkFillModal($event)"  maxlength="13" type="text" id="number_io" ref="number_io"/>
      <br>
      <p>Tipo de contrato:</p>
      <b-form-select id="filter-types" ref="contract_status_option" @change="checkFillModal($event)" class="form-control selectStatusInFilter" v-model="filters.status" :options="filter_types_listOptions"/>
      <br>
      <br>
      <div v-show="show_cups_luz">
        <p>CUPS Luz:</p>
        <input class="form-control" @keyup="checkFillModal($event)"  maxlength="22" type="text" id="cups_luz" ref="cups_luz"/>
        <br>
      </div>
      <div v-show="show_cups_gas">
        <p>CUPS Gas:</p>
        <input class="form-control" @keyup="checkFillModal($event)"  maxlength="22" type="text" id="cups_gas" ref="cups_gas"/>
        <br>
      </div>
      <p>Adjuntar PDF:</p>
      <input id="inputFile" type="file" accept="application/pdf" @change="UploadFile($event)" ref="inputFile"/>
      <div id="msgAddFiles"></div>
      <b-button  ref="btnaddfiles" id="btnaddfiles" class="btn btn-secondary Btnalt" :disabled="isvalidFile" @click="addFiles()">Añadir</b-button>
    </b-modal>
  </div>
</template>

<script>
  import Vue from "vue";
  import VueResource from "vue-resource";
  Vue.use(VueResource);
  import constants from "../../assets/environments/constants.json";
  export default {
    name: "alta",
    data() {
      const now = new Date()
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      today.setDate(today.getDate() + 1)
      const minDate = new Date(today)
      return {
        popup: false,
        spiner:false,
        noTabletSize: "",
        tabletSize: "",
        refactorEnv: "",
        pdfBase64 : "",
        value: '',
        idNeed: '',
        phoneNo: '',
        errorMessage: '',
        nif: '',
        min: minDate,
        errorsMsg:[],
        filter_types_listOptions: [],
        filters: {},
        contract_list:[],
        contract:{number_io:'',type_contract:'',file:'',fileBase64:''},
        headTitle:['Numero OI','Tipo de contrato','CUP','Documento Contrato', 'Eliminar'],
        isSocial : false,
        isvalidFile :true,
        disabledAddFiles:false,
        radioSelected: 'nif',
        show_cups_luz: false,
        show_cups_gas: false
      };
    },
    created() {
      if(this.$session.has("token")){this.token = this.$session.get("token")}
      else{this.redirect()}
      this.refactorEnv = this.$session.get("settings")
      window.addEventListener("resize", this.handleAlta)
      this.buildTypesListSelector()
    },
    mounted() {
      this.handleAlta()
      this.$refs.pbtnalt.innerHTML = constants.defaultText;
    },
    computed: {
      filterAccordionBtnText() {
        return this.filterVisible ? '-' : '+';
      },
      getInputMaxLength() {
        return this.radioSelected === 'nif' ? 9 : 12;
      }
    },
    methods: {
      clearBeforeSending(text) {
        let clearedText = text.trim();
        clearedText = clearedText.replace(/^[\t]+|[\t]+$/g, '');
        clearedText = clearedText.replace(/[\t]+/g, ' ');
        return clearedText;
      },
      handleAlta() {
        if (window.innerWidth < constants.minSizeTablet) {
          this.noTabletSize = false
          this.tabletSize = true
        } else {
          this.noTabletSize = true
          this.tabletSize = false
        }
      },
      changeRadioNif() {
        if (this.$refs.nif.value.length > this.getInputMaxLength) {
          this.$refs.nif.value = '';
        }
      },
      userPersona(){
        this.$refs.persona.style.backgroundColor = '#278BED'
        this.$refs.sociedad.style.backgroundColor = '#5A6268'
        this.isSocial = false
        this.fieldValidate()
      },
      userSociedad(){
        this.$refs.sociedad.style.backgroundColor = '#278BED'
        this.$refs.persona.style.backgroundColor = '#5A6268'
        this.isSocial = true
        this.fieldValidate()
      }
      ,
      test(){
        var email = this.$refs.email.value
        var emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
        alert(emailRegex.test(email))
      },
      addFilesModal(){
        this.$refs['addfile_modal'].show()

      },
      addFiles(){
        var contract={}
        contract.number_io = this.$refs.number_io.value
        contract.type_contract = this.$refs.contract_status_option.value
        if (this.show_cups_luz) {
          contract.cups_luz = this.$refs.cups_luz.value
        }else if (this.show_cups_gas) {
          contract.cups_gas = this.$refs.cups_gas.value
        }
        var contract_file = this.$refs.inputFile.files[0]
        if(contract_file != "" && contract_file != undefined){
          contract.file_name = contract_file.name
          contract.fileBase64 = this.pdfBase64
        }else{
           contract.file_name = ""
          contract.fileBase64 = ""
        }

        if (contract.number_io != '' && contract.type_contract != '' && contract.type_contract != undefined && contract.file_name != '' && contract.fileBase64 != ''){
          this.contract_list.push(contract)

          this.$refs['addfile_modal'].hide()
        }
        else {
          document.getElementById('msgAddFiles').innerHTML = "Rellene todos los campos para continuar"
        }
        if(this.contract_list.length >= constants.max_doc_to_send){this.disabledAddFiles=true}
        this.fieldValidate()
      },
      eraseContractFromList(numberIO){
        let newList = this.contract_list.filter(element => element.number_io !== numberIO);
        this.contract_list = newList;
        if(this.contract_list.length < constants.max_doc_to_send){
          this.disabledAddFiles=false;
        }
      },
      async enviar(){
        if( this.fieldValidate()){
          this.$emit('changeSpinner', true)
          var nif = this.clearBeforeSending(this.$refs.nif.value)
          var name = this.clearBeforeSending(this.$refs.name.value)
          var surname1 = this.clearBeforeSending(this.$refs.surname1.value)
          var surname2 = this.clearBeforeSending(this.$refs.surname2.value)
          var address = this.clearBeforeSending(this.$refs.address.value)
          var phone_num = this.phoneNo
          var id_need = this.idNeed.toString()
          var razon_social = ''
          var cif = ''
          if (this.isSocial){
            razon_social = this.clearBeforeSending(this.$refs.social.value)
            cif = this.clearBeforeSending(this.$refs.cif.value)
          }
          var apikey = constants.apikey
          let payload = {apikey:apikey ,number_need: id_need,name: name,surname1: surname1,surname2: surname2, address: address,
              nif: nif, phone : phone_num, social : razon_social, cif : cif, id_user :this.$session.get("id") ,contract_list :this.contract_list};

          let url = this.refactorEnv.createContract
          await this.$http.post(url,payload,{headers: {'Authorization': this.token,'key': "Content-Type",'value': "application/json",'type': "text"}})
            .then(response => (this.exito()))
            .catch(error =>{
              this.$emit('changeSpinner', false)
              this.errorsMsg = []
              if(error.status == constants.cod_400){this.dealError(JSON.parse(error.bodyText))}
              if(error.status == constants.cod_401 || error.status == constants.cod_500){this.getMsg(error.status)}
            })
        }
      },
      cerrarPopup(){
        this.popup = false
      },
      exito(){
        this.empytForm()
        this.popup = true
        this.$emit('changeSpinner', false)
      },
      toggleInfo(event) {
        if (this.tabletSize) {
          var idClick = event.currentTarget.id
          var idChange = "more" + idClick
          var element = document.getElementById(idChange)
          if (element.hasAttribute("hidden")) {
            element.removeAttribute("hidden")
          } else {
            element.setAttribute("hidden", true)
          }
        }
      },
      DisableBtn: function(evt) {
        this.fieldValidate()
      },
      UploadFile:  function(evt) {
        this.getBase64(this.$refs.inputFile.files[0])
        this.checkFillModal(evt)
      },
      getBase64(file) {
        var vm = this
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function () {
          vm.pdfBase64 = reader.result.split(constants.trimBase64)[1];
        }
        reader.onerror = function (error) {
          console.log("error")
          vm.pdfBase64 = null
        }
      },
      linkGen(pageNum) {
        return pageNum === 1 ? "?" : `?page=${pageNum}`
      },
      redirect() {
        this.$session.destroy()
        this.$router.push({
          name: "login"
        })
      },
      fieldValidate(){
        this.$refs.pbtnalt.style.color = "red";
        this.errorMessage = "";
        var fieldList =[
          this.idNeed,
          this.phoneNo,
          this.$refs.nif.value,
          this.$refs.name.value,
          this.$refs.surname1.value,
          this.$refs.surname2.value,
          this.$refs.address.value
        ]
        if( this.isSocial){
          fieldList.push(this.$refs.cif.value)
          fieldList.push(this.$refs.social.value)
        }
        let isValid = true;

        if(fieldList.includes("")){
          isValid = false;
          this.errorMessage = constants.msgFieldsKO;
        }else{
          var isNeedValid = this.checkIdNeed();
          var isPhoneValid = this.okPhone();
          var isDniValid = this.radioSelected === 'nif' ? this.okDni() : true;
          var isCifValid = this.isSocial ? this.validateCIF() : true;
          isValid = isNeedValid && isPhoneValid && isDniValid && isCifValid;
        }

        if( isValid && this.contract_list.length == 0 ){
          isValid = false;
          this.errorMessage = constants.emptyContractList;
        }
        if (isValid){
          this.$refs.pbtnalt.innerHTML = constants.msgFieldsOk;
          this.$refs.pbtnalt.style.color = "green";
        }else{
          this.$refs.pbtnalt.innerHTML = this.errorMessage;
          this.$refs.pbtnalt.style.color = "red";
        }
        this.$refs.Btnalt.disabled = !isValid;
        return isValid;
      },
      checkIdNeed(){
        const CHECK_NUMBERS_EXPRESSION = /^\d+$/;
        const NOT_PERMITED_FIRST_CHARACTERS = ['6', '7'];

        var need = this.idNeed.toString();
        let isValid = true;
        document.getElementById("idNeed").style.border='';
        if( need.length < constants.minSizeIdNeed){
          isValid = false;
          this.errorMessage = constants.msgIdNeedKOSize;
          document.getElementById("idNeed").style.border='1px solid red';
        }
        if (NOT_PERMITED_FIRST_CHARACTERS.includes(need.charAt(0))){
          isValid = false;
          this.errorMessage = constants.msgIdNeedKOFirstLetter
          document.getElementById("idNeed").style.border='1px solid red'
        }
        return isValid
      },
      limitDigits(evt, fieldName, limit) {
        let number = evt.target.value
        if (number !== null && number.toString().length > limit) {
          this[fieldName] = parseInt(number.toString().slice(0, limit));
        }
      },
      okPhone(){
        var validPhone = false;
        if (this.phoneNo.length > 9) {
          validPhone = this.phoneNo.match(/(\+34)[0-9]{9}/g)
        }
        else{
          validPhone = this.phoneNo.match(/[0-9]{9}/g)
        }
        if(validPhone==null){
          this.errorMessage = constants.msgPhoneKo
          document.getElementById('Numbertlf').style.border='1px solid red'
          return false
        }else{
          document.getElementById('Numbertlf').style.border=''
        }
        return true
      },
      okDni() {
        const DNI_EXPRESION = /^\d{8}[a-zA-Z]$/;
        const NIE_EXPRESION = /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
        const VALID_LETTERS = 'TRWAGMYFPDXBNJZSQVHLCKET';

        var dni = this.$refs.nif.value;
        var isValidDni = DNI_EXPRESION.test(dni);
        var isValidNie = NIE_EXPRESION.test(dni);
        if (isValidNie){
          return true; //No se necesitan comprobaciones adicionales
        }

        if (isValidDni) {
          var number = isValidDni ? dni.slice(0, -1) % 23 : null;
          var letter = isValidDni ? dni.slice(-1).toUpperCase() : null;
          if (VALID_LETTERS.charAt(number) !== letter) {
            this.errorMessage = constants.msgNifKo;
            document.getElementById('nif').style.border = '1px solid red';
            return false;
          } else {
            document.getElementById('nif').style.border = '';
            return true;
          }
        }

        this.errorMessage = constants.msgNifKo;
        document.getElementById('nif').style.border = '1px solid red';
        return false;
      },
      validateCIF(){
        const CIF_LETTERS = "TRWAGMYFPDXBNJZSQVHLCKET";
        const CIF_EXPRESION = /^[a-zA-Z]{1}\d{7}[a-zA-Z0-9]{1}$/;

        var cif = this.$refs.cif.value;
        var validCif = CIF_EXPRESION.test(cif);
        if(!validCif){
          this.errorMessage = constants.msgCifKo;
          document.getElementById('cif').style.border='1px solid red';
          return false;
        }else{
          document.getElementById('cif').style.border = '';
          return true;
        }
      },
      openModal(){
        this.$refs['msg_modal'].show()
      },
      hideModal() {
        this.$refs['msg_modal'].hide()
      },
      dealError(error){
        error = error.descError.split('. ')
        error = error[1]
        error = error.replaceAll(/['{}."]/g,"")
        var errors = error.split(',')
        errors.forEach(element =>this.formatMsg(element) );
        this.openModal()
      },
      formatMsg(row){
        row = row.split(":")
        var textPlus = ''
        if(row[1].includes(constants.isReq)){textPlus = constants.isRequired}
        else if(row[1].includes(constants.isTooLong)){textPlus = constants.isTooL}
        else if(row[1].includes(constants.isTooShort)){textPlus = constants.isTooS}
        var campo = ''
        var campos = constants.word_collection
        for(var element in campos ){if(element == row[0]){campo = campos[element]}}
        var msg ='El campo ' + campo + textPlus
        this.errorsMsg.push(msg)
      },
      getMsg(error){
        var msg = constants.error_401
        if(error == constants.cod_500){msg = constants.error_500}
        this.errorsMsg.push(msg)
        this.openModal()
      },
      async buildTypesListSelector() {
        await this.$http.post(this.refactorEnv.getContractTypes,{}, { headers: {
          'Authorization': this.token
        }}).then(response => {
          var aux = []
          response.body.types_list.forEach(function(value, index, array){
            aux.push({ "value" : value.Id,"text":value.Estado })
          });
          this.filter_types_listOptions = aux;
        }).catch(error => {console.log(error)});
      },
      checkFillModal: function(evt){
        var contractStatus = this.$refs.contract_status_option.value
        if (!isNaN(evt)){contractStatus = evt}
        var numberOI = this.$refs.number_io.value
        var file_input = this.$refs.inputFile.files[0]
        var cups_valid = false

        this.showCups(contractStatus)

        if (this.show_cups_luz) {
          if (this.$refs.cups_luz.value.length > 19 && this.$refs.cups_luz.value.length < 23) {
            cups_valid = true
          }
        }else if (this.show_cups_gas) {
          if (this.$refs.cups_gas.value.length > 19 && this.$refs.cups_gas.value.length < 23) {
            cups_valid = true
          }
        }else {
          cups_valid = true
        }

        if(numberOI.length==constants.max_size_OI && contractStatus != undefined  && file_input!=undefined && cups_valid ){this.validateNumberOI()}
        else{
          this.isvalidFile = true
          document.getElementById('msgAddFiles').innerHTML = ''
          document.getElementById('number_io').style.border=''
        }
      },
      showCups(contractStatus){
        if (contractStatus == 1) {
          this.show_cups_luz = false
          this.show_cups_gas = true
        }
        else if (contractStatus == 2) {
          this.show_cups_luz = true
          this.show_cups_gas = false
        }
        else if(!this.show_cups_luz || !this.show_cups_gas){
          this.show_cups_luz = false
          this.show_cups_gas = false
        }
      },
      validateNumberOI(){
        var numberOI = this.$refs.number_io.value
        var exp_numberOI = /^OI-[a-zA-Z0-9]/;
        if(exp_numberOI.test (numberOI)){
          this.isvalidFile = false
          document.getElementById('msgAddFiles').innerHTML = ''
          document.getElementById('number_io').style.border=''
        }
        else{
          this.isvalidFile = true
          document.getElementById('msgAddFiles').innerHTML = constants.msgNameOiKO
          document.getElementById('number_io').style.border='1px solid red'
        }
      },
      empytForm(){
        this.$refs.pbtnalt.style.color = "black";
        this.$refs.pbtnalt.innerHTML = constants.defaultText;
        this.contract_list = [];
        this.$refs.nif.value = '';
        this.idNeed = '';
        this.$refs.name.value = '';
        this.$refs.surname1.value = '';
        this.$refs.surname2.value = '';
        this.$refs.address.value = '';
        this.phoneNo = '';
        this.$refs.social.value = '';
        this.$refs.cif.value = '';
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/alta/alta.vue